import { useEffect, useRef } from 'react';
import { AttendanceTableConfig } from './data/AttendanceTableConfig';
import { AttendanceSubmissionFormData } from './data/AttendanceSubmissionForm.Data';
import FormCreator from '../../components/Forms/FormCreator';
import Buttons from '../../components/ui/button/Buttons';
import MolGrid from '../../components/Grid/MolGrid';
import { useState } from 'react';
import { useGetAllApproveAttendanceSubmissionMutation } from '../../app/services/GMPCourseProvider/GMPCoursePoviderApi';
import { encryptAESID } from '../../utils/Encryption';
import { useNavigate } from 'react-router-dom';
import { useLazyGetAllDropDownsForMemberDirectoryQuery } from '../../app/services/common/commonApi';

import { setAllDropDownFields } from './utils/setDropDownFields';

const AttendanceSubmissionList = () => {
  const molGridRef = useRef();
  const AttendanceSubmissionRef = useRef();
  const navigate = useNavigate();
  const [formData, setFromData] = useState(AttendanceSubmissionFormData);
  const [dataSource, setDataSource] = useState()
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    organisationName: "",
    courseEventName: "",
    attendanceSubmittedDate: null,
    SourceId:null
  });

  const [getAllApproveAttendanceSubmission, { isSuccess: isgetAllApproveAttendanceSubmission, isLoading: isLoadingCourseProvider, data: getAllApproveAttendanceSubmissionDataResponse },] = useGetAllApproveAttendanceSubmissionMutation();
  const [getAllDropDowns, { data: allDropDownResponse, isSuccess: isGetAllDropDownSuccess, isFetching: isGetDropDownFetching, isLoading: dropdownListLoading, },] = useLazyGetAllDropDownsForMemberDirectoryQuery()

  useEffect(() => {
    getAllDropDowns()
    getAllApproveAttendanceSubmission(paginationRequest)
  }, [])

  useEffect(() => {
    if (!isGetDropDownFetching && isGetAllDropDownSuccess && allDropDownResponse) {
      setAllDropDownFields(allDropDownResponse);
    }
}, [isGetDropDownFetching, isGetAllDropDownSuccess, allDropDownResponse]);
  useEffect(() => {
    if (!isLoadingCourseProvider && isgetAllApproveAttendanceSubmission && getAllApproveAttendanceSubmissionDataResponse) {
      setPaginationRequest(prev => ({ ...prev, totalCount: getAllApproveAttendanceSubmissionDataResponse.totalCount }));
      setDataSource(getAllApproveAttendanceSubmissionDataResponse?.itemList);
    }
  }, [isLoadingCourseProvider, isgetAllApproveAttendanceSubmission, getAllApproveAttendanceSubmissionDataResponse]);

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getAllApproveAttendanceSubmission(updatedPaginationRequest);
  };

  const handleSearch = () => {
    if (!AttendanceSubmissionRef.current) {
      return;
    }
    const attendanceListFormData = AttendanceSubmissionRef.current.getFormData();
    const updatedPaginationRequest = {
      PageNo: 1,
      PageSize: 20,
      OrganisationName: attendanceListFormData?.organisationName || "",
      CourseEventName: attendanceListFormData?.courseEventName || "",
      AttendanceSubmittedDate: attendanceListFormData?.attendanceSubmittedDate || null,
      SourceId:attendanceListFormData?.statusId?.value || null
    };
    setPaginationRequest(updatedPaginationRequest);
    getAllApproveAttendanceSubmission(updatedPaginationRequest);
  };

  const handleViewClick = (data) => {
    navigate(`/cpdAttendance/${encryptAESID(data.cpdEventId)}`)
  }

  const actionHandler = {
    View: handleViewClick,
  };

  const handleClear = ()=>{
    const formData = {...AttendanceSubmissionFormData}
    formData.initialState={
      
      organisationName:  null,
      courseEventName: null,
      attendanceSubmittedDate:  null,
      statusId:null
    }
    let request={
      pageNo:1,
      PageSize:20,
      OrganisationName:  null,
      CourseEventName: null,
      AttendanceSubmittedDate:  null,
      SourceId:null
    }
    setPaginationRequest(prev=>{return{...prev,...request}});
    getAllApproveAttendanceSubmission(request)
    setFromData(formData)
  }

  return (
    <div>
      <div className="form-section">
        <div className="row">
          <div className="row col-10">
            {!isGetDropDownFetching &&
            <FormCreator ref={AttendanceSubmissionRef} {...formData} />
            }
            
          </div>
          <div className="btn-sec col-2 mt-auto mb-2 course-search-btn">
          <Buttons
              buttonText="Clear"
              buttonTypeClassName="btn success-btn ml-auto mr-0 "
              onClick={handleClear}
            />
            <Buttons
              buttonText="Search"
              buttonTypeClassName="btn success-btn ml-auto mr-0 mt-3"
              onClick={handleSearch}
            />
          </div>
        </div>
      </div>
      <div className="mt-4">
        <MolGrid
          ref={molGridRef}
          configuration={AttendanceTableConfig}
          dataSource={dataSource}
          allowPagination={true}
          isLoading={isLoadingCourseProvider}
          pagination={paginationRequest}
          onPageChange={handlePageChange}
           onActionChange={actionHandler}
        />
      </div>
    </div>
  )
}

export default AttendanceSubmissionList;